import React from 'react';
import { Col, Container, InputGroup, InputGroupText, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';

const Page404 = ({ t }) => {
  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="6">
            <div className="clearfix">
              <h1 className="float-left display-3 mr-4">404</h1>
              <p className="text-muted float-left">{t("Page404.unavailable")}</p>
            </div>
            <InputGroup className="input-prepend">
              <div className="input-group-append">
              {/* <InputGroupAddon addonType="prepend"> */}
                <InputGroupText>
                  <i className="fa fa-search" />
                </InputGroupText>
              {/* </InputGroupAddon> */}
              </div>
            </InputGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default withTranslation()(Page404);
